module.exports = __webpack_public_path__ + "static/media/1.a4a96994.png";